import axios from "@/libs/api.request";

export const SaveRole = data => {
  return axios.request({
    url: "/print/admin/role",
    method: "post",
    data
  });
};



export const GetRole = params => {
  return axios.request({
    url: "/print/admin/role",
    method: "get",
    params
  });
};


export const GetAdminUser = params => {
  return axios.request({
    url: "/print/admin/user",
    method: "get",
    params
  });
};


export const SaveAdminUser = data => {
  return axios.request({
    url: "/print/admin/user",
    method: "post",
    data
  });
};
